import r2a from '../angularIntegration/r2a';

import { TimesheetErrorTip } from './TimesheetErrorTip';

export const rTimesheetErrorTip = r2a({
  ReactComponent: TimesheetErrorTip,
  bindings: {
    active: '<',
  },
});
